export function Device({device_id, status, room_id, update_time}) {
  this.deviceId = device_id;
  this.status = status;
  this.roomId = room_id;
  this.updateTime = update_time;
}

export function getDeviceType(did) {
  if (did.startsWith("P")) {
    // People Count => Footfall
    return "Footfall";
  } else if (did.startsWith("F")) {
    return "Feedback";
  } else if (did.startsWith("N")) {
    return "Nano";
  }
}
